import { hasWindow } from "@omni/utils/dom.utils";

import {
    PureAemComponent,
    registerComponent
} from "@/components/pureAemComponent";
import * as ScrollPositionService from "@/services/scrollPosition.service";

class PageLink extends PureAemComponent {
    private readonly _anchorElements: Array<HTMLAnchorElement>;

    constructor(element: HTMLElement) {
        super(element);
        this._anchorElements = this._getAnchorElements();

        this._registerEventHandlers();
    }

    private _registerEventHandlers() {
        this._anchorElements.forEach((anchorElement) => {
            anchorElement.addEventListener("click", () =>
                ScrollPositionService.pushPosition(
                    0,
                    anchorElement.href ?? window.location.href
                )
            );
        });
    }

    private _getAnchorElements() {
        return this.element
            .querySelectorAll("a")
            .values()
            .filter((element) => element instanceof HTMLAnchorElement)
            .toArray();
    }
}

const InitPageLink = () => {
    hasWindow() && registerComponent(".page-link", PageLink);
};

export { InitPageLink };
